import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import Spacer from "@ui/spacer/Spacer";
import { Fees } from "../forms/Fees";
import { ITerminal } from "src/types/types";
import { useRouter } from "src/services/Router";

interface TMerchantTerminalPopupProps {
	onSuccess?: () => void;
	merchantTerminal: ITerminal;
	clientId: number;
	merchantId: number;
}

export const S_MERCHANT_TERMINAL_POPUP = new Signal<TMerchantTerminalPopupProps | null>("S_MERCHANT_TERMINAL_POPUP");

export const MerchantTerminalPopup = () => {
	useLocale();
	const request = S_MERCHANT_TERMINAL_POPUP.use();
	const router = useRouter();

	if (!request) return null;

	const closePopup = () => {
		S_MERCHANT_TERMINAL_POPUP.invoke(null);
	};

	const openMerchant = () => {
		closePopup();
		router.navigate("merchantterminal", {
			mid: request.merchantId + "",
			cid: request.clientId + "",
			tid: request.merchantTerminal.id + "",
		});
	};

	return (
		<Panel
			contentPadding="0px 20px 20px 20px"
			sx={{
				width: "90vw",
				maxWidth: "600px",
				padding: "0",
				height: "90vh",
				backgroundColor: "#EEF0F2",
			}}
			decorator="absolute"
			label={msg("merchant_ac66cc4c") + request.merchantTerminal.name}
			onClose={closePopup}>
			{/* <VBox sx={{ height: "100%", overflow: "hidden" }}> */}
			<Spacer size="20px" />
			<Fees
				target_id={request.merchantTerminal.link_id}
				target_type="merchant_terminal"
				parent_target_id={request.merchantTerminal.id}
				onComplete={closePopup}
				buttons={[
					{
						title: msg("showTerminal"),
						variant: "secondary",
						onClick: openMerchant,
					},
				]}
			/>
			{/* </VBox> */}

			{/* <Spacer size="20px" />
			<HBox gap="12px" sx={{ width: "100%" }}>
				<Spacer grow />
				<Button
					variant="primary"
					title="Open merchant terminal"
					onClick={() => {
						closePopup();
						router.navigate("merchantterminal", {
							mid: request.merchantId + "",
							cid: request.clientId + "",
							tid: request.merchantTerminal.id + "",
						});
					}}
				/>

				<Button
					variant="primary"
					title="Close"
					onClick={() => {
						closePopup();
					}}
				/>
			</HBox> */}
		</Panel>
	);
};
